module.exports = __webpack_public_path__ + "img/spotters.a087e0bf.png";